import { RegexMatch } from "@/data/enums/router";

export default [
  {
    path: "support",
    alias: "tickets",
    component: {
      name: "AdminAccountTickets",
      template: `<router-view />`
    },
    meta: {
      title: "_.tickets"
    },
    children: [
      {
        path: "",
        name: "admin__upmindSupport",
        component: () => import("@/views/admin/upmind/tickets/index.vue"),
        meta: {
          title: "_.support",
          backTo: "_.support"
        }
      },
      {
        path: "add",
        name: "admin__addUpmindTicket",
        component: () =>
          import("@/views/admin/upmind/tickets/ticket/index.vue"),
        meta: {
          title: "_action.open_new_ticket",
          backTo: "_action.open_new_ticket"
        }
      },
      {
        path: `:ticketId(${RegexMatch.UUID})`,
        name: "admin__upmindTicket",
        props: true,
        component: () =>
          import("@/views/admin/upmind/tickets/ticket/details.vue"),
        meta: {
          title: "_.manage_ticket"
        }
      }
    ]
  }
];
